import { useCallback, useState } from "react";

export const useNumericKeyboard = (initialAmount: number) => {
    const [amount, setAmount] = useState<number>(initialAmount || 0)
    const [isKeyboardPressedForTheFirstTime, setIsKeyboardPressedForTheFirstTime] = useState<boolean>(false)

    const handleKeyboardPress = useCallback((value: string) => {
        if (value === 'delete') {
            setAmount(prev => {
                if (prev > 0) {
                    return Number(prev.toString().slice(0, -1)) || 0;
                }
                return prev;
            });
            return;
        }

        setAmount(prev => {
            // Convert to string, append the new digit, then convert back to number
            return Number(prev.toString() + value);
        });
        setIsKeyboardPressedForTheFirstTime(true)
    }, []);

    return {
        amount,
        setAmount,
        handleKeyboardPress,
        isKeyboardPressedForTheFirstTime
    }
}